module.exports = __webpack_public_path__ + "static/media/dash-bg.ea468476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dash-bg.jpg
// module id = 1134
// module chunks = 1